import React from "react"
import NavLink from "../NavLink"
import CurrencyContext from "../../context/CurrencyContext"
import Pricing from "../ui/Pricing"
import { useStaticQuery, graphql } from "gatsby"

const HostingBlock = ({ pid, gid }) => {
  // Fetch all products
  const allData = useStaticQuery(graphql`
    query {
      allProductsContentJson {
        edges {
          node {
            gid
            block_title
            block_description
            block_cta
            slug
          }
        }
      }
      allProductsJson {
        edges {
          node {
            pid
            name
            description
            pricing {
              INR {
                prefix
                suffix
                monthly
                annually
              }
              MYR {
                prefix
                suffix
                monthly
                annually
              }
              SGD {
                prefix
                suffix
                monthly
                annually
              }
              USD {
                prefix
                suffix
                monthly
                annually
              }
              GBP {
                prefix
                suffix
                monthly
                annually
              }
            }
            configoptions {
              configoption {
                options {
                  option {
                    pricing {
                      INR {
                        monthly
                        annually
                      }
                      MYR {
                        monthly
                        annually
                      }
                      SGD {
                        monthly
                        annually
                      }
                      USD {
                        monthly
                        annually
                      }
                      GBP {
                        monthly
                        annually
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  `);

  const product = allData.allProductsJson.edges.find(edge => edge.node.pid === pid)?.node;
  const productContent = allData.allProductsContentJson.edges.find(edge => edge.node.gid === gid)?.node;
 
  if (!product) {
    return null;
  }
  const { pricing } = product;
  return (
    <div className="col-12 col-md-4 ">
      <div className="card mb-3 border">
        <div className="card-body ">
          <h3 className="card-title">{productContent.block_title}</h3>
          <div className="small-text">{productContent.block_description}</div>
          <div className="card-text">
            <div className="fw-bolder">Starting from</div>
            <div className="fs-32 fw-bolder mb-3">
              <CurrencyContext.Consumer>
                {(context) => (
                  <Pricing
                    CurrencyPrefix={pricing}
                    pricing={pricing}
                    productID={pid}
                  />
                )}
              </CurrencyContext.Consumer>
            </div>
          </div>
          <NavLink
            to={productContent.slug}
            className="stretched-link btn"
          >
           {productContent.block_cta}
            <i className="bi bi-arrow-right float-end"></i>
          </NavLink>
        </div>
      </div>
    </div>
  )
}

export default HostingBlock
